module.exports = __webpack_public_path__ + "files/12380ce9fff4c631e5afa39d5589a12d.png";